import { render, staticRenderFns } from "./chess.vue?vue&type=template&id=64e563d2&scoped=true&"
import script from "./chess.vue?vue&type=script&lang=js&"
export * from "./chess.vue?vue&type=script&lang=js&"
import style0 from "./chess.vue?vue&type=style&index=0&id=64e563d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e563d2",
  null
  
)

export default component.exports